export const DENIED_BY_SANCTIONS_LINK = 'https://www.cian.ru/help/quality/37646/';
